import { Manage } from "./Manage";

export const Integrations = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Google</span>
        <Manage service="google" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Apple</span>
        <Manage service="apple" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Github</span>
        <Manage service="github" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Github Personal</span>
        <Manage service="github_personal" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Gitlab</span>
        <Manage service="gitlab" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Trello</span>
        <Manage service="trello" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Atlassian</span>
        <Manage service="atlassian" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Toggl</span>
        <Manage service="toggl" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Pinterest</span>
        <Manage service="pinterest" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Bitrix24</span>
        <Manage service="bitrix24" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Linear</span>
        <Manage service="linear" />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Slack</span>
        <Manage service="slack" />
      </div>
    </div>
  );
};
